import alamedaImg from 'assets/images/alameda.png';

export const FUNDS = {
  devnet: [
    {
      address: 't72redTRJkPtUmTWWvPyjnkFKGVrHakv3DBQTheY4oD',
      fundName: 'Alameda Bull DTF',
      fundSymbol: 'AB',
      icon: alamedaImg,
    },
  ],
};
